import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ShieldX } from 'lucide-react';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Super admin has access to everything except super_admin-only routes when not super_admin
  const hasAccess = allowedRoles.length === 0 || 
                    allowedRoles.includes(user.role) ||
                    (user.role === 'super_admin' && !allowedRoles.includes('super_admin'));

  if (!hasAccess) {
    // Determine redirect based on role
    const redirectPath = user.role === 'super_admin' ? '/super-admin/dashboard' : '/dashboard';
    
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-8">
        <div className="text-center max-w-md" data-testid="access-denied">
          <div className="h-20 w-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldX className="h-10 w-10 text-red-500" />
          </div>
          <h1 className="text-2xl font-heading font-bold text-slate-900 mb-2">
            Acceso no autorizado
          </h1>
          <p className="text-slate-500 mb-6">
            No tienes permisos para acceder a esta sección. Contacta a tu administrador si crees que esto es un error.
          </p>
          <a
            href={redirectPath}
            className="inline-flex items-center px-6 py-3 bg-accent text-white font-medium rounded-full hover:bg-accent/90 transition-colors"
          >
            Ir al Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
